import React, { useContext, useState } from "react";
import { Form } from "react-bootstrap";
import Login_Green_Btn from "../../Common-Component/common_btn/login_green_btn/Login_Green_Btn";
import { useForm } from "react-hook-form";
import { Context } from "../../../utils/context";
import classNames from "classnames";
import {
  CheckExist,
  emailOtpGet,
} from "../../../utils/apis/myAccount/myAccount";
import { RegxExpression } from "../../../utils/common";
import Reset_Password from "./Reset_Password";

const Forgot_Password = ({
  setSuccessModalShow,
  onHide,
  setFormType,
  setSuccessText,
  ...props}
) => {
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const [modalShow, setModalShow] = useState(false);
  const [showSetNewPassword, setShowSetNewPassword] = useState(false);
  const [showCheckYourEmail, setShowCheckYourEmail] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const { signin, setSignin, shimmerLoader, setShimmerLoader } =
    useContext(Context);
  const [email, setEmail] = useState("");

  const onSubmit = async (data) => {
    setShimmerLoader(true);
    const res = await CheckExist(data);
    if (res?.success) {
      emailOtpGet(data);
      setEmail(data?.email);
      // setShowCheckYourEmail(true);
      setModalShow(true);
      setTimeout(() => {
        setShimmerLoader(false);
        setShowCheckYourEmail(false);
        setShowSetNewPassword(true);
        setModalShow(false);
      }, 3000);
    } else {
      setShimmerLoader(false);
      setError("email", { message: "User Not Found With This E-mail" });
      // setError('contact_no', { message: "" });
    }
  };

  return (
    <div className="Login_Form">
      <>
        {!showSetNewPassword && !showLogin && !showCheckYourEmail && (
          <>
            <div className="logo_content">
              <div className="logo_holder">
                <img
                  src="/assets/Image/Logo/Local-MandaiFinal-Logo.png"
                  className="logo_img"
                />
              </div>
              <p className="modal_haeding">Forgot Password</p>
            </div>

            <div className="form_holder">
              <Form>
                <Form.Group className="input_group" controlId="">
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Enter Email"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: RegxExpression.email,
                        message: "Invalid email address",
                      },
                    })}
                    className={classNames("", {
                      "is-invalid": errors?.email,
                      "is-valid": getValues("email"),
                    })}
                  />
                  {errors?.email && (
                    <div className="mt-2">
                      <sup className="text-danger  ">
                        {errors?.email?.message}
                      </sup>
                    </div>
                  )}
                </Form.Group>

                <div className="submit_btn_div">
                  <Login_Green_Btn
                    btn_name="Submit"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>

                <p
                  className="create_acc_text"
                  onClick={() => {
                    setFormType("login");
                  }}
                >
                  Back
                </p>
              </Form>
            </div>
          </>
        )}

        {showSetNewPassword && (
          <Reset_Password
            email={email}
            onHide={() => onHide()}
            setSuccessModalShow={setSuccessModalShow}
            setFormType={setFormType}
            setSuccessText={setSuccessText}
            setShowSetNewPassword={setShowSetNewPassword}
          />
        )}
      </>
    </div>
  );
};

export default Forgot_Password;
